export var FulfilmentWindowSummarySlot;
(function (FulfilmentWindowSummarySlot) {
    FulfilmentWindowSummarySlot.StatusEnum = {
        Unknown: 'Unknown',
        Available: 'Available',
        ClosingSoon: 'Closing Soon',
        Closed: 'Closed',
        Full: 'Full',
        Unavailable: 'Unavailable',
        Selected: 'Selected'
    };
})(FulfilmentWindowSummarySlot || (FulfilmentWindowSummarySlot = {}));
